<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<!-- div class="c-section__header">
		<h1 class="c-section__title c-section__title--sm">{{ 'History.Title' | translate }}:</h1>
	</div-->
	<div class="c-section__content">
		<list-services type="history" [descriptionDisabled]="true" [initialLimit]="9999"></list-services>
	</div>
</section>
